function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import { useHover } from 'react-native-web-hooks';
import { Colors, Spacer, Text, Icon } from 'advance-components';
const WIDTH = 210;
const ItemContainer = styled.View`
  padding-horizontal: 16px;
  padding-vertical: 12px;
  width: ${WIDTH}px;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${_ref => {
  let {
    hovered
  } = _ref;
  return hovered ? Colors.lightGray200 : Colors.white;
}};
`;
const ItemLeft = styled.View`
  flex-direction: row;
  align-items: center;
`;
const SubMenuContainer = styled.View`
  position: absolute;
  top: 0;
  left: -${WIDTH}px;
`;
export default function RightMenuItem(_ref2) {
  let {
    label,
    icon,
    onPress,
    subItems
  } = _ref2;
  const ref = useRef();
  const hovered = useHover(ref);
  return /*#__PURE__*/React.createElement(ItemContainer, {
    ref: ref,
    hovered: hovered
  }, /*#__PURE__*/React.createElement(ItemLeft, null, icon && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: icon,
    size: 16,
    color: hovered ? Colors.purple400 : Colors.gray400
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    width: true
  })), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    onPress: onPress,
    color: hovered ? Colors.purple400 : Colors.gray600
  }, label)), !!(subItems !== null && subItems !== void 0 && subItems.length) && /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "chevron-right",
    size: 16,
    color: hovered ? Colors.purple400 : Colors.gray300
  }), hovered && !!(subItems !== null && subItems !== void 0 && subItems.length) && /*#__PURE__*/React.createElement(SubMenuContainer, null, subItems.map((subItem, index) => /*#__PURE__*/React.createElement(RightMenuItem, _extends({
    key: index
  }, subItem)))));
}
RightMenuItem.defaultProps = {
  label: '',
  icon: '',
  onPress: () => {},
  subItems: []
};
RightMenuItem.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  onPress: PropTypes.func,
  subItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.string,
    onPress: PropTypes.func,
    subItems: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.string,
      onPress: PropTypes.func,
      subItems: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        icon: PropTypes.string,
        onPress: PropTypes.func
      }))
    }))
  }))
};
//# sourceMappingURL=right-menu-item.js.map